import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
// import {OperatorSettings} from '@/constants/operators'
import OperatorsIcon from "@/components/OperatorIcons";
import { useOperator } from "@/stores/operator-store";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LoadingSpinner } from "@/components/ui/loading";
import { Separator } from "@/components/ui/separator";
import Pulse from "@/components/Pulse";
import { RefreshCcw } from "lucide-react";
export const Route = createFileRoute("/operator/status/")({
  component: OperatorStatus,
});

function OperatorStatus() {
  const { isLoading, refetch, status } = useOperator();

  // const checkActive = (operator: string) => {
  //   return Boolean(operators?.find((o) => o.name.toLowerCase() === operator)?.status)
  // }

  useEffect(() => {
    console.log(status);
  }, [status]);

  // const checkSettingActive = (operator: string, setting: keyof typeof OperatorSettings) => {
  //   return Boolean(operators?.find((o) => o.name.toLowerCase() === operator)?.setting[setting])
  // }

  return (
    <>
      <Card>
        <CardHeader className="flex flex-row justify-between items-center">
          <CardTitle>وضعیت اپراتور ها</CardTitle>

          <Button isLoading={isLoading} onClick={() => refetch()}>
            <RefreshCcw className="size-5 ml-2" />
            دریافت مجدد وضعیت ها
          </Button>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <LoadingSpinner className="size-7" />
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 mt-2">
              {status.map((s, i) => (
                <Card key={i}>
                  <CardHeader className="flex flex-row justify-between items-center">
                    <CardTitle>{s.title}</CardTitle>
                    <Pulse isActive={s.status} />
                  </CardHeader>
                  <CardContent>
                    <div>
                      <OperatorsIcon
                        operator={s.name}
                        className="size-20 mx-auto"
                        operatorColors
                      />
                    </div>
                    <Separator className="my-2" />
                    <div className="flex flex-col ">
                      {s.setting.map((e, id) => (
                        <div key={id}>
                          <div className={`flex justify-between items-center`}>
                            {e.title}
                            <Pulse isActive={e.status} size="size-2" />
                          </div>
                          <Separator className="my-2" />
                        </div>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </>
  );
}
